import { MANIFEST_TYPE } from 'Manifest/constants';
import React from 'react';
import PropTypes from 'prop-types';

export const Ifca = (props) => {
  const {
    handleSubmit,
    errors = {},
    manifestFormActions,
    onChange,
    form,
    sup_name,
    sphone,
    curDate,
    formatDate,
    crewOptions,
    vehicleOptions,
    handleOnViewResourceOrderForm,
    manifestType,
    printManifest = () => {},
    viewOnly = false,
  } = props;

  return (
    <div id='view_print_manifest' className='print_manifest_wrap'>
      <h2>{viewOnly ? 'View' : 'Finalize'} Manifest</h2>
      <form id='form3' onSubmit={handleSubmit}>
        <fieldset disabled={viewOnly}>
          <div id='view_printing_page'>
            <div
              className='responsive_table ifca_view_manifest'
              id='view_general_information_table'
            >
              <div className='top_table table'>
                <div className='tr'>
                  <div className='print_center td top_title' colSpan='5'>
                    <h3>
                      {manifestType === MANIFEST_TYPE.IFCA_Manifest
                        ? 'Exhibit P - '
                        : 'Exhibit 1 - '}
                      <span>Hand Crew Manifest Form</span>
                    </h3>
                  </div>
                </div>
                <div className='tr ifca_ordering'>
                  <div className='td' data-header-title='Ordering Unit'>
                    <h4>Ordering Unit</h4>
                    <input
                      type='text'
                      errors={errors.unitError}
                      placeholder='Fill...'
                      id={'orderingUnit' + manifestType}
                      name='ordering_unit'
                      value={form.ordering_unit}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td' data-header-title='Incident Name'>
                    <h4>Incident Name</h4>
                    <input
                      type='text'
                      errors={errors.incidentNameError}
                      placeholder='Fill...'
                      id={'incidentName' + manifestType}
                      name='incident_name'
                      value={form.incident_name}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td' data-header-title='Incident Number'>
                    <h4>Incident Number</h4>
                    <input
                      type='text'
                      errors={errors.IncidentNumError}
                      placeholder='Fill...'
                      id={'incidentNumber' + manifestType}
                      name='incident_number'
                      value={form.incident_number}
                      onChange={onChange}
                    />
                  </div>
                  <div
                    className='td_split td'
                    data-header-title='Resource Number'
                  >
                    <h4>Resource Number</h4>
                    <b>C-</b>{' '}
                    <span>
                      <input
                        type='text'
                        errors={errors.resourceError}
                        placeholder='Fill...'
                        id={'resourceNumber' + manifestType}
                        name='resource_number'
                        value={form.resource_number}
                        onChange={onChange}
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className='top_table no_border table'>
                <div className='tr contrac1'>
                  <div
                    className='td'
                    data-header-title='Contractor'
                    width='36%'
                  >
                    <h4>Contractor</h4>
                    <p>Firestorm Wildland Fire Supression Inc.</p>
                  </div>
                  <div
                    className={
                      manifestType === MANIFEST_TYPE.ODF
                        ? 'td_split_s td'
                        : 'td'
                    }
                    data-header-title='Agreement Number'
                  >
                    <h4>Agreement Number</h4>
                    {manifestType === MANIFEST_TYPE.ODF ? <b>IRA </b> : ''}
                    <span>
                      <input
                        type='text'
                        errors={errors.ifcaError}
                        placeholder='Fill...'
                        id={'ifcaNumber' + manifestType}
                        name='ifca_number'
                        value={form.ifca_number}
                        onChange={onChange}
                      />
                    </span>
                  </div>
                  <div
                    className='td'
                    data-header-title='Designated Dispatch Location'
                  >
                    <h4>Designated Dispatch Location</h4>
                    <input
                      type='text'
                      errors={errors.dispatchError}
                      placeholder='Fill...'
                      id={'dispatchLocation' + manifestType}
                      name='dispatch_location'
                      value={form.dispatch_location}
                      onChange={onChange}
                    />
                  </div>
                </div>
                <div className='tr contrac2'>
                  <div
                    className='td'
                    data-header-title='Contractor Representative'
                  >
                    <h4>Contractor Representative</h4>
                    <p id='sup_det_view'>{sup_name}</p>
                  </div>
                  <div className='td' data-header-title='Contact Phone'>
                    <h4>Contact Phone:</h4>
                    <p id='sup_phone_view'>{sphone}</p>
                  </div>
                  <div className='td' data-header-title='Report To'>
                    <h4>Report To:</h4>
                    <input
                      type='text'
                      errors={errors.reportToError}
                      placeholder='Fill...'
                      id={'reportTo' + manifestType}
                      name='report_to'
                      value={form.report_to}
                      onChange={onChange}
                    />
                  </div>
                </div>
              </div>
              <div className='table top_table no_border place'>
                <div className='tr'>
                  <div
                    width='36%'
                    className='td print_center no_padding_border'
                  >
                    <div className='table top_table no_border departure_div'>
                      <div className='tr'>
                        <div
                          className='print_center td_height td tr_title depar_div'
                          colSpan='3'
                          data-header-title='Departure'
                        >
                          <h5>Departure</h5>
                        </div>
                      </div>
                      <div className='tr'>
                        <div
                          width='50%'
                          className='double_field td'
                          data-header-title='Place'
                        >
                          <h5>Place</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.desPlaceError}
                              placeholder='Fill...'
                              id={'depPlace' + manifestType}
                              name='dep_place'
                              value={form.dep_place}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                        <div
                          className='double_field td'
                          data-header-title='ETD'
                        >
                          <h5>ETD</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.desEtaError}
                              placeholder='Fill...'
                              id='depETD1'
                              name='dep_etd'
                              value={form.dep_etd}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                        <div
                          className='double_field td'
                          data-header-title='ETA'
                        >
                          <h5>ETA</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.desEtdError}
                              placeholder='Fill...'
                              id='depETA1'
                              name='dep_eta'
                              value={form.dep_eta}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='td print_center no_padding_border'
                    width='23%'
                  >
                    <div className='table top_table no_border interm_div'>
                      <div className='tr'>
                        <div
                          className='print_center td_height td tr_title'
                          data-header-title='Intermediate Stops'
                        >
                          <h5>Intermediate Stops</h5>
                        </div>
                      </div>
                      <div className='tr'>
                        <div
                          className='double_field td'
                          data-header-title='Place'
                        >
                          <h5>Place</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.interSpaceError}
                              placeholder='Fill...'
                              id={'interSpace' + manifestType}
                              name='inter_space'
                              value={form.inter_space}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='print_center no_padding_border td'>
                    <div className='top_table no_border table destin_div'>
                      <div className='tr'>
                        <div
                          className='print_center td_height tr_title td'
                          data-header-title='Place'
                          colSpan='3'
                        >
                          <h5>Destination</h5>
                        </div>
                      </div>
                      <div className='tr'>
                        <div
                          className='double_field td'
                          data-header-title='Place'
                        >
                          <h5>Place</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.depPlaceError}
                              placeholder='Fill...'
                              id={'desPlace' + manifestType}
                              name='des_place'
                              value={form.des_place}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                        <div
                          className='double_field td'
                          data-header-title='ETD'
                        >
                          <h5>ETD</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.depEtdError}
                              placeholder='Fill...'
                              id={'desETD' + manifestType}
                              name='des_etd'
                              value={form.des_etd}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                        <div
                          className='double_field td'
                          data-header-title='ETA'
                        >
                          <h5>ETA</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.depEtaError}
                              placeholder='Fill...'
                              id={'desETA' + manifestType}
                              name='des_eta'
                              value={form.des_eta}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='responsive_table'>
              <div
                className='table top_table table_space ifca_employee_details'
                id='view_employee_details_table'
              >
                <p className='mobile_crew'>Crew Details</p>
                <div className='thead'>
                  <div className='tr'>
                    <div
                      className='print_center th'
                      data-header-title='Crew Member Name'
                    >
                      <h4>Crew Member Name</h4>
                    </div>
                    <div
                      className='print_center gender th'
                      data-header-title='M'
                    >
                      <h4>M</h4>
                    </div>
                    <div
                      className='print_center gender th'
                      data-header-title='F'
                    >
                      <h4>F</h4>
                    </div>
                    <div
                      className='print_center crew_mem_no th'
                      data-header-title='Crew Member Number'
                    >
                      <h4>
                        Crew Member
                        <br />
                        Number
                      </h4>
                    </div>
                    <div
                      className='print_center th'
                      data-header-title='Incident Position'
                    >
                      <h4>
                        Incident
                        <br />
                        Position
                      </h4>
                    </div>
                    <div
                      className='print_center th Sawyer'
                      data-header-title='Sawyer'
                    >
                      <h4>Sawyer</h4>
                    </div>
                    <div
                      className='print_center th emt'
                      data-header-title='EMT'
                    >
                      <h4>EMT</h4>
                    </div>
                    <div
                      className='print_center th'
                      data-header-title={
                        manifestType === MANIFEST_TYPE.IFCA_Manifest
                          ? 'Experience and Lsa (Blue-Red-Yellow)'
                          : 'Experience B-R-Y Blue-Red-Yellow'
                      }
                    >
                      {manifestType === MANIFEST_TYPE.IFCA_Manifest ? (
                        <h4>
                          Experience and Lsa
                          <br />
                          <span>(Blue-Red-Yellow)</span>
                        </h4>
                      ) : (
                        <h4>
                          Experience
                          <br />
                          B-R-Y
                          <br />
                          <span>Blue-Red-Yellow</span>
                        </h4>
                      )}
                    </div>
                  </div>
                </div>
                <div className='tbody'>{crewOptions}</div>
              </div>
            </div>
            <div className='responsive_table view_driver_vehicle_div'>
              <h3 className='inner_head_title'>
                Driver and Vehicle Information
              </h3>
              <div
                className='table top_table no_border ifca_driver_vehicle_table'
                id='view_driver_vehicle_table'
              >
                <div className='thead'>
                  <div className='tr'>
                    <div className='td no_border_td_right'>
                      <h6>Driver Name</h6>
                    </div>
                    <div className='td no_border_td_right'>
                      <h6>License Number/State</h6>
                    </div>
                    <div className='td no_border_td_right mdate'>
                      <h6>MSPA Exp. Date</h6>
                    </div>
                    <div className='td no_border_td_right'>
                      <h6>Vehicle Make/Model</h6>
                    </div>
                    <div className='td no_border_td_right'>
                      <h6>Vehicle License No.</h6>
                    </div>
                  </div>
                </div>
                <div className='tbody'>{vehicleOptions}</div>
              </div>
            </div>

            <div className='responsive_table ifca_sign'>
              <div className='table top_table last_table'>
                <div className='tr'>
                  <div className='td'>
                    <span className='title_bottom'>
                      Signature of Authorized Company Representative (Print)
                    </span>
                    <p id='sup_det_view'>{sup_name}</p>
                  </div>
                  <div className='td'>
                    <span className='title_bottom'>Date</span>
                    <br />
                    <span className='print_date'>{formatDate(curDate)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='clearFix' />
          {manifestFormActions}
        </fieldset>
        {viewOnly && (
          <div className='gear-option-btn-wrap'>
            <input
              type='button'
              id='to_view_final_print'
              className={`button save_manifest`}
              name='print'
              onClick={printManifest}
              value='Print Manifest'
            />
            {form.resource_order_form && handleOnViewResourceOrderForm && (
              <input
                type='button'
                id='view_ROF'
                onClick={() => handleOnViewResourceOrderForm()}
                value='View RO'
                name='view_ROF'
                className={`button save_manifest}`}
              />
            )}
          </div>
        )}
      </form>
    </div>
  );
};

Ifca.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  viewOnly: PropTypes.bool,
  manifestType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  printManifest: PropTypes.func,

  sup_name: PropTypes.string,
  sphone: PropTypes.string,
  curDate: PropTypes.any,
  formatDate: PropTypes.func.isRequired,

  crewOptions: PropTypes.node,
  vehicleOptions: PropTypes.node,

  errors: PropTypes.object,
  manifestFormActions: PropTypes.node,

  form: PropTypes.shape({
    ordering_unit: PropTypes.string,
    incident_name: PropTypes.string,
    incident_number: PropTypes.string,
    resource_number: PropTypes.string,
    ifca_number: PropTypes.string,
    dispatch_location: PropTypes.string,
    report_to: PropTypes.string,
    dep_place: PropTypes.string,
    dep_etd: PropTypes.string,
    dep_eta: PropTypes.string,
    inter_space: PropTypes.string,
    des_place: PropTypes.string,
    des_etd: PropTypes.string,
    des_eta: PropTypes.string,
    resource_order_form: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object,
    ]),
  }).isRequired,

  handleOnViewResourceOrderForm: PropTypes.func,
};
